
/**
 * @typedef {import('../../js-doc').V1BatchCreateBuyoutsRequest} V1BatchCreateBuyoutsRequest
 * @typedef {import('../../js-doc').V2BatchCreateBuyoutsRequest} V2BatchCreateBuyoutsRequest
 */
export class BuyoutMapper {
  /**
   * @param {V1BatchCreateBuyoutsRequest} v1Request - V1 create batch buyout request body
   * @returns {V2BatchCreateBuyoutsRequest} - V2 create batch buyout request body
   */
  static v1BatchCreateToV2 (v1Request) {
    return {
      batch: v1Request.batch.map((batch) => {
        return {
          id: batch.id,
          clientId: batch.client_id,
          buyoutDate: batch.buyout_invoice_date,
          loadNumber: String(batch.load_number),
          brokerName: batch.debtor_name,
          rate: batch.rate,
          mc: batch.mc,
        }
      }),
      __ingestThrough: true,
      __v1Payload: v1Request,
    }
  }
}
